import { UserGroup } from 'data/userGroups/types'
import { RootState } from 'duck/store'
import { Corporate } from 'entities-next/corporate'
import { isEmpty, isNil, some } from 'lodash'
import { createSelector } from 'reselect'

import { getDashboardState } from '../../../duck/selectors'
import { DEAL_MANAGER_STATE_ID, IsValidFilter } from './types'

export const getDealManagerState = createSelector(
  getDashboardState,
  (dashboardState) => dashboardState.scenes[DEAL_MANAGER_STATE_ID]
)

export const getIsFetchingDeals = createSelector(getDealManagerState, (dealManagerState) => dealManagerState.isLoading)

export const getDealManagerFilters = createSelector(getDealManagerState, (dealManagerState) => dealManagerState.filters)

export const getDealManagerIsValidFilter = createSelector(getDealManagerFilters, ({ isValidFilter }) => isValidFilter)

export const getDealManagerFinderStagesFilter = createSelector(
  getDealManagerFilters,
  ({ finderStagesFilter }) => finderStagesFilter
)

export const getDealManagerCorporateStatusFilter = createSelector(
  getDealManagerFilters,
  ({ corporateStatusFilter }) => corporateStatusFilter
)

const getAllUsers = createSelector(getDealManagerState, (dealManagerState) => dealManagerState.users)
export const getDraftUser = (state: RootState, corporateId: Corporate['id']) => {
  return createSelector(getAllUsers, (allUsers) => allUsers[corporateId] as Corporate | undefined)(state)
}

const getAllUserGroups = createSelector(getDealManagerState, (dealManagerState) => dealManagerState.userGroups)
export const getDraftUserGroup = (state: RootState, userGroupId?: UserGroup['id']) => {
  return userGroupId
    ? createSelector(getAllUserGroups, (allUserGroups) => allUserGroups[userGroupId])(state)
    : undefined
}

export const getOrderedDeals = createSelector(getDealManagerState, (dealManagerState) => {
  return dealManagerState.dealsOrder
})

export const isDealManagerSearchEnabled = createSelector(
  getDealManagerFilters,
  ({ scoutingCampaignId, finderStagesFilter, corporateSearch, organizationSearch, isValidFilter }) =>
    some(
      [scoutingCampaignId, finderStagesFilter, corporateSearch, organizationSearch, isValidFilter],
      (value) =>
        !isNil(value) && value !== '' && !(Array.isArray(value) && isEmpty(value)) && value !== IsValidFilter.all
    )
)
